import moment from 'moment'
import _ from 'lodash'
import { userPermissions, countryUsersAccess } from '@/utils/userAccess'

export const sort = (property) => {
  let sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
    const result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0
    return result * sortOrder
  }
}

export const sortAlpha = (property) => {
  let sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    /* next line works with strings and numbers,
       * and you may want to customize it to your needs
       */
    const result = (a[property].toUpperCase() < b[property].toUpperCase()) ? -1 : (a[property].toUpperCase() > b[property].toUpperCase()) ? 1 : 0
    return result * sortOrder
  }
}

export const getParam = (object: any, field: string, param: string) => {
  if (!object || !(object.keys) || (object.keys.length > 0) || !param || !field) {
    return false
  } else {
    const found = (object).find((x: any) => x[field] === param)
    if (found) return found
    else return false
  }
}

export const cleanObject = (object: any) => {
  Object
    .entries(object)
    .forEach(([k, v]) => {
      if (v && typeof v === 'object') {
        cleanObject(v)
      }
      // eslint-disable-next-line no-mixed-operators
      if (v && typeof v === 'object' && !Object.keys(v).length || v === null || v === undefined || v === '') {
        if (Array.isArray(object)) {
          object.splice((k as any), 1)
        } else if (!(v instanceof Date)) {
          delete object[k]
        }
      }
    })
  return object
}

export const dateFormatter = (params) => {
  return params.value ? moment(params.value).format('DD/MM/YYYY') : ''
}

export const dateFormatterOther = (params) => {
  return params ? moment(params).format('YYYY-MM-DD') : ''
}

export const fileToBase64 = (file): any => new Promise((resolve, reject) => {
  const reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = () => resolve(reader.result)
  reader.onerror = error => reject(error)
})

export const removeCabecera = (base64String) => {
  const index = base64String.indexOf(',') + 1
  const cortar = base64String.slice(0, index)
  return base64String.replace(cortar, '')
}

export const dateTimeFormatter = (params) => {
  return params.value ? moment(params.value).format('DD-MM-YYYY hh:mm:ss') : ''
}

const getBase64Header = (extension) => {
  switch (extension) {
    case '.xls':
    case '.xlsx':
      return 'data:application/vnd.ms-excel;base64,'
    case '.pdf':
      return 'data:application/pdf;base64,'
    default:
      return 'data:application/json;base64,'
  }
}

export const downloadFile = async (stream, name: string, extension?: string) => {
  if (extension) {
    name = name.concat(extension)
  } else {
    extension = name.substring(name.indexOf('.'))
  }
  const cabecera = getBase64Header(extension)
  const blob = new Blob([cabecera.concat(stream)])
  const reader = new FileReader()
  reader.readAsBinaryString(blob)
  reader.onload = (e) => {
    const link = document.createElement('a')
    link.href = e.target.result.toString()
    link.setAttribute('download', name)
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}

export const MONTH_AND_YEAR_REG = (val) => {
  return !/^(0[1-9]|1[0-2])\/\d{2}$/.test(val)
}

export const slFormat = (params) => {
  return params.value ? params.value + '%' : ''
}

export const accessVerification = (mName, resID) => {
  const matchedMenu = _.find(userPermissions(), { menuName: mName })
  const matchedResource = _.find(matchedMenu?.resources, { resourceId: resID })
  return matchedResource?.active
}

export const higherWResolution = () => {
  const resolutionCheck = window.matchMedia('(max-width: 1366px)')
  return resolutionCheck.matches
}

export const allCountryUserAccess = () => {
  const countryList = countryUsersAccess() || []
  return [...countryList]
}
export const lpCountryUserAccess = () => {
  const countryList = allCountryUserAccess() || []
  return (countryList?.length > 0 ? countryList.filter(row => row.logisticPenalty) : [])
}

export const slpCountryUserAccess = () => {
  const countryList = allCountryUserAccess() || []
  return (countryList?.length > 0 ? countryList.filter(row => row.serviceLevelPenalty) : [])
}

export const cpCountryUserAccess = () => {
  const countryList = allCountryUserAccess() || []
  return (countryList?.length > 0 ? countryList.filter(row => row.cashPenalty) : [])
}

export const startPenaltyTypeScreen = (flag = 'home') => {
  const countryList = allCountryUserAccess() || []
  const typeObj = { lp: null, slp: null, cp: null }
  if (lpCountryUserAccess()?.length > 0) {
    typeObj.lp = 'LogisticPenalty'
  } else if (slpCountryUserAccess()?.length > 0) {
    if (flag === 'agreementNote' && cpCountryUserAccess()?.length > 0) {
      typeObj.lp = 'LogisticPenalty'
    } else {
      typeObj.slp = 'ServicePenalties'
    }
  } else if (cpCountryUserAccess()?.length > 0) {
    if (flag === 'agreementNote') {
      typeObj.lp = 'LogisticPenalty'
    } else {
      typeObj.cp = 'CashPenalty'
    }
  } else if (countryList?.length > 0) {
    typeObj.lp = 'LogisticPenalty'
  }
  return typeObj
}

export const getCurrencySymbol = (currencyId) => {
  let currency = ''
  switch (currencyId?.toUpperCase()) {
    case 'EUR':
      currency = '€'
      break
    case 'PLN':
      currency = 'PLN'
      break
    case 'RON':
      currency = 'RON'
      break
  }
  return currency
}

export const getCurrencyIdFromCountryId = (countryId) => {
  const countryList = allCountryUserAccess() || []
  const selectedCountry = countryList?.length > 0 ? countryList.filter(row => row?.countryId === countryId) : []
  return selectedCountry?.length > 0 ? selectedCountry[0]?.currencyId : ''
}

export const currencyFormat = (params) => {
  const currencyId = getCurrencyIdFromCountryId(params?.data?.countryId)
  const currency = getCurrencySymbol(currencyId)
  return params?.value + ' ' + currency
}

export const getCurrencyFromCountryName = (countryName) => {
  const countryList = allCountryUserAccess() || []
  const selectedCountry = countryList?.length > 0 ? countryList.filter(row => row?.countryName === countryName) : []
  return selectedCountry?.length > 0 ? getCurrencySymbol(selectedCountry[0]?.currencyId) : ''
}
